// extracted by mini-css-extract-plugin
module.exports = {"dialog":"ModalPrompt--dialog--3yvpg","overlay":"ModalPrompt--overlay--3Yt7l","content":"ModalPrompt--content--1VHe6"};